import { useEffect, useState } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import map from '~/assets/icons/map.svg';
import { playSound, Sound } from '~/assets/sounds';
import { useLayoutSelector } from '../../redux';
import { faqContent } from '../FAQ/FAQ.model';
import { TextLabel } from '../TextLabel';
import {
	StyledBackgroundImage,
	StyledContainer,
	StyledMapButton,
	StyledTextContainer,
} from './FAQContent.styled';

const FAQContent = () => {
	const faqSectionIndex = useLayoutSelector(
		(state) => state.mainMenu.faqSectionIndex,
	);
	const faqIndex = useLayoutSelector((state) => state.mainMenu.faqIndex);
	const [previousSectionIndex, setPreviousSectionIndex] = useState(0);
	const [previousIndex, setPreviousIndex] = useState(0);

	useEffect(() => {
		if (faqIndex !== -1) {
			setPreviousIndex(faqIndex);
		}
		if (faqSectionIndex !== -1) {
			setPreviousSectionIndex(faqSectionIndex);
		}
	}, [faqSectionIndex, faqIndex]);

	return (
		<SwitchTransition>
			<CSSTransition
				timeout={300}
				classNames={'faq'}
				key={previousIndex + previousSectionIndex * 10}
				addEndListener={(node, done) =>
					node.addEventListener('transitionend', done, false)
				}
			>
				<StyledContainer>
					<StyledBackgroundImage />
					<TextLabel
						style={{ fontSize: 30, fontWeight: 500, color: '#ffffff' }}
					>
						{faqContent[previousSectionIndex].items[previousIndex].title}
					</TextLabel>
					<StyledTextContainer $button>
						<TextLabel style={{ fontSize: 16, color: '#ffffff', opacity: 0.5 }}>
							{faqContent[previousSectionIndex].items[previousIndex].text}
						</TextLabel>
					</StyledTextContainer>
					<StyledMapButton
						onClick={() => {
							playSound(Sound.ClickButton);
						}}
						onMouseEnter={() => playSound(Sound.LinkCursor)}
					>
						<img src={map} />
						<TextLabel>Отметить на карте</TextLabel>
					</StyledMapButton>
				</StyledContainer>
			</CSSTransition>
		</SwitchTransition>
	);
};

export { FAQContent };
